import { lazy, Suspense } from "react";
import { Route, Switch, useHistory, useParams, useRouteMatch } from "react-router-dom";
import { ViewportCenterCircle } from "@newComponents/common/ViewportCenterCircle";
import { tryBigIntParse } from "@newRoutes/paramValidators";
import { FolderContext, useFolderContext } from "@newHooks/context/folder/folder.context";

const MyDocumentBrowseFolderPage = lazy(() => import("@newPages/myDocuments/MyDocumentBrowseFolderPage"));
const MyDocumentsFileDetailPage = lazy(() => import("@newPages/myDocuments/MyDocumentsFileDetailPage"));

function MyDocumentRouteInner() {
  const history = useHistory();
  const match = useRouteMatch();
  const { folderId: folderIdStr } = useParams<{ folderId: string }>();
  const { folderIds: parentFolderIds } = useFolderContext();

  const folderIds = folderIdStr ? parentFolderIds.concat(tryBigIntParse(folderIdStr, history)) : parentFolderIds;
  const currentFolderId = folderIds.length > 0 ? folderIds.slice(-1)[0] : undefined;

  return (
    <FolderContext.Provider value={{ folderIds, currentFolderId }}>
      <Suspense fallback={<ViewportCenterCircle />}>
        <Switch>
          <Route exact path={`${match.url}/files/:fileId(\\d+)`} component={MyDocumentsFileDetailPage} />
          <Route path={`${match.url}/:folderId(\\d+)`} render={() => <MyDocumentRouteInner />} />
          <Route exact path={`${match.url}`} component={MyDocumentBrowseFolderPage} />
        </Switch>
      </Suspense>
    </FolderContext.Provider>
  );
}

export function MyDocumentRoute() {
  const match = useRouteMatch();

  return (
    <FolderContext.Provider value={{ folderIds: [] }}>
      <Switch>
        <Route path={`${match.url}`} render={() => <MyDocumentRouteInner />} />
      </Switch>
    </FolderContext.Provider>
  );
}
